<script setup>
import CenterLayout from './CenterLayout.vue'
import {MediaUploaderButton, Icon, MediaUploaderModal} from '@components'

import { ref } from 'vue'

const image = ref('')

import {useSettings} from '@store/settings';
const $settings = useSettings();
</script>

<template>
  <CenterLayout>
    <MediaUploaderModal />
    <MediaUploaderButton :crop="true" :ratio="80 / 60" name="chat_widget_banner_image" v-model="$settings.settings.chat_widget.top_banner" dummy class="mt-1.5 w-full">
      <div class="flex flex-col gap-4 w-[382px] m-auto h-[212px] bg-white rounded-[14px] font-medium text-xs items-center justify-center">
        <Icon name="image01" size="48px" />
        <div>Drop your image here or <span class="text-[#6941C6] font-semibold">browse</span></div>
      </div>
    </MediaUploaderButton>

    <template #sidebar>
      <div class="mt-[44px]">
        <div class="text-[#101828] text-xs font-semibold">Pro Tips</div>
        <div class="text-[#101828] text-lg font-semibold mt-1">Top Banner</div>
        <ul class="pl-5 mt-1 text-sm text-[#475467] list-disc">
          <li>Add your banner here</li>
          <li>SVG, PNG, JPG or GIF (max. 800x400px)</li>
        </ul>
      </div>
    </template>
  </CenterLayout>
</template>


<style>

</style>